// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_lq2","cls2":"ProfilePdfPackCard-cls2_WdT ProfilePdfPackCard-cls1_lq2"};